module.exports = __webpack_public_path__ + "static/media/cost.a37baa1a.svg";